import React, { FC } from 'react';
import { Button, ButtonIcon, Tooltip } from '@cubeyou-team/hx-react-components';

interface PreviewAudienceButtonProps {
  isQueryLoading: boolean;
  isQueryPreviewVisible: boolean;
  onPreviewQueryRequest: () => void;
  isStaleyQueryEnabled?: boolean;
}

export const PreviewAudienceButton: FC<PreviewAudienceButtonProps> = ({
  isQueryLoading,
  isQueryPreviewVisible,
  onPreviewQueryRequest,
  isStaleyQueryEnabled,
}) => {
  const props = {
    icon: !isQueryPreviewVisible ? 'show' : 'hide',
    size: 'small',
    variant: isStaleyQueryEnabled ? 'subtle' : 'outlined',
    type: 'button',
    id: 'gtQueryPreview',
    disabled: isQueryLoading,
    'data-test-id': 'query-preview',
    onClick: onPreviewQueryRequest,
  };

  return (
    <Tooltip
      content={
        !isQueryPreviewVisible ? 'Show query preview' : 'Hide query preview'
      }
      position="bottom"
      isInfoLabel
    >
      {isStaleyQueryEnabled ? (
        <ButtonIcon {...props} />
      ) : (
        <Button {...props}>Preview</Button>
      )}
    </Tooltip>
  );
};
